import React, { useContext, useState } from "react";
import "./deleteloanlist.scss";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { Grid, Stack, Box, TextField } from "@mui/material";
import { useMutation } from "@apollo/client";
//Schema
import { DELETE_LOAN } from "../../../Schema/Loanlist";
//Components
import { AuthContext } from "../../../context/AuthContext";
import { translateLauguage } from "../../../Function/Translate";

export default function DeleteLoanList({
  open,
  handleClose,
  editData,
  setRefetch,
}) {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [confirmVal, setConfirmVal] = React.useState("");
  const [loading, setLoading] = useState(false);

  const { setAlert } = useContext(AuthContext);

  const [deleteLoan] = useMutation(DELETE_LOAN, {
    onCompleted: ({ deleteLoan }) => {
      if (deleteLoan?.isSuccess) {
        setAlert(true, "success", deleteLoan?.message);
        setRefetch();
        handleClose();
        setLoading(false);
      } else {
        setAlert(true, "error", deleteLoan?.message);
        setLoading(false);
      }
    },
    onError: (error) => {
      // console.log(error);
      setAlert(true, "error", error?.message);
      setLoading(false);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteLoan({
      variables: {
        deleteLoanId: editData?._id,
      },
    });
  };

  return (
    <Dialog open={open} onClose={handleClose} className="loanlist-delete">
      <DialogTitle className="dialog-title">
        <Stack direction="row"  spacing={2}>
          <Typography className={language === "kh" ? "titleKh" : "titleEn"}>
            {t("delete") + t("loan list")}
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <CloseIcon className="clear-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          <Typography variant="subtitle1" className={language === "kh" ? "simple-textKh" : "simple-textEn"}>
            {t("do-you-want-to-delete")}
          </Typography>

          <Stack direction="row" spacing={1}>
            <Typography variant="subtitle1"  className={language === "kh" ? "simple-textKh" : "simple-textEn"}>
              {t("please-input")}
            </Typography>
            <Typography className={language === "kh" ? "body-textKh" : "body-textEn"} variant="subtitle1">
              LOAN LIST
            </Typography>
            <Typography variant="subtitle1"  className={language === "kh" ? "simple-textKh" : "simple-textEn"}>
              {t("to-delete")}
            </Typography>
          </Stack>
          <TextField
            fullWidth
            size="small"
            type="text"
            onChange={(e) => setConfirmVal(e.target.value)}
          />
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box className="action">
              {confirmVal === "LOAN LIST" ? (
                <Button
                  sx={{ ":hover": { backgroundColor: "red", border: "none" } }}
                  className={language === "kh" ? "btn-voidKh" : "btn-voidEn"}
                  variant="outlined"
                  fullWidth
                  onClick={handleDelete}
                >
                  {loading ? "Loading..." : t("delete-now") }
                </Button>
              ) : (
                <Button variant="outlined" className="btn-delete" fullWidth>
                  {t("delete")}
                </Button>
              )}
            </Box>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
